import {
  ADDITIONAL_VALIDATION_MESSAGES,
  CORE_VALIDATION_MESSAGES,
  ValidationMessages,
} from './models';

export const DEFAULT_VALIDATION_MESSAGES = {
  default: {
    required: 'This field is required',
    email: 'Please enter a valid email address',
    password: 'Please enter a valid password',
    passwordConfirm: 'Passwords do not match',
  },
};

export function provideCoreValidationMessages(
  messages: ValidationMessages = {}
) {
  return [
    {
      provide: CORE_VALIDATION_MESSAGES,
      useValue: messages,
    },
  ];
}

export function provideAdditionalValidationMessages(
  messages: ValidationMessages = {}
) {
  return [
    {
      provide: ADDITIONAL_VALIDATION_MESSAGES,
      useValue: messages,
    },
  ];
}
